import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { QQQuestionnairePageViewModel } from 'src/app/models/qq-questionnaire-page.view-model';

@Component({
  selector: 'app-cover-questions',
  templateUrl: './cover-questions.component.html',
  styleUrls: ['./cover-questions.component.scss'],
})
export class CoverQuestionsComponent implements OnInit {

  @Input() page: QQQuestionnairePageViewModel;
  @Input() showBackButton: boolean = false;
  @Output() back = new EventEmitter();
  constructor() { }

  ngOnInit() {

  }
}
